export function setMetaTag(company = null) {
    // const tag = document.createElement('meta')
    // tag.setAttribute('title', info.companies[0].slugName)
    const host = window.location.host;
    const parts = host.split(".");
    let domain = "";
    if ((parts[0] == 'admin' || parts[0] == 'tulaadmin' || parts[0].indexOf("localhost") > -1) && company == null) {
        if (parts[1] == 'vknows') {
            domain = 'vknows'
        } else if (parts[1] == 'nerdof') {
            domain = 'nerdof'
        } else if (parts[1] == 'clsedo') {
            domain = 'clsedo'
        }else {
            domain = 'nerdof'
        }
    } else {
        domain = "other"
    }

    let title = ""
    let logo = ""

    if (domain == "vknows") {
        title = "VKNOWS - Content Management"
        // logo = "../assets/icon/vknows.ico"
        logo = "https://s3-ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/Logo/vknows.ico"
    } else if (domain == 'nerdof') {
        title = "NerdOf - Content Management"
        logo = "https://s3-ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/Logo/nerdof.ico"
    }
    else if (domain == 'clsedo') {
        title = "CLSEDO - Content Management"
        logo = "https://s3-ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/Logo/clsedo.ico"
    } else {
        title = `${company.title} - Content Management`
        logo = company.logo
    }
    console.log(domain)
    document.title = title
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'image/gif/png/icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = logo;
}